import { NgModule } from '@angular/core';
import { CategoryComponent } from './category.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [CategoryComponent],
  exports: [CategoryComponent],
})
export class CategoryModule {}
